import React, { createContext, useReducer } from 'react';

import {
  TCompanyOffice,
  TUsersData,
  TUserTypeRolesData,
  TVisibilityState,
} from 'modules/settings/models';

const INITIAL_USER_TYPE_MODULES_STATE: TUserTypeRolesData = {
  customerId: '',
  modules: [],
  roleId: '',
  roleName: '',
};

const INITIAL_USERS_STATE: TUsersData = {
  users: [],
  userId: null,
};

const INITIAL_COMPANY_OFFICE_STATE: TCompanyOffice = {
  id: '',
  officeName: '',
};

const INITIAL_VISIBILITY_STATE: TVisibilityState = {
  // UserManagement props
  isUpsertUserTypeVisible: false,
  userTypeRoleId: null,
  deleteModalUsername: '',
  userTableView: 0,
  warningInvitationModalVisible: false,
  warningInvitationModalUsername: '',

  // ProfileSettings props
  //ProfileDetails
  isChangePasswordVisible: false,
  isCompanyDetailsVisible: false,

  //CompanyDetails
  isCompanyOfficeVisible: false,
  isCompanyListVisible: true,

  //BillingInformation
  isBillingInformationDetailsVisible: true,
  isBillingInformationFormsVisible: false,

  // ProfileSettings and UserManagement common props
  isDeleteModalVisible: false,
  isSidebarOpen: false,
};

interface IUserManagementContext {
  userTypeModulesState: TUserTypeRolesData;
  usersState: TUsersData;
  userVisibilityState: TVisibilityState;
  companyOfficeState: TCompanyOffice;

  setUserTypeModulesState: (newState: Partial<TUserTypeRolesData>) => void;
  setUsersState: (newState: Partial<TUsersData>) => void;
  setcompanyOfficeState: (newState: Partial<TCompanyOffice>) => void;
  setUserVisibilityState: (newState: Partial<TVisibilityState>) => void;
}

export const UserManagementContext = createContext<IUserManagementContext>(
  {} as IUserManagementContext,
);

export const UserManagementContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [userTypeModulesState, setUserTypeModulesState] = useReducer(
    (state: TUserTypeRolesData, newState: Partial<TUserTypeRolesData>): TUserTypeRolesData => ({
      ...state,
      ...newState,
    }),
    INITIAL_USER_TYPE_MODULES_STATE,
  );

  const [userVisibilityState, setUserVisibilityState] = useReducer(
    (state: TVisibilityState, newState: Partial<TVisibilityState>): TVisibilityState => ({
      ...state,
      ...newState,
    }),
    INITIAL_VISIBILITY_STATE,
  );

  const [usersState, setUsersState] = useReducer(
    (state: TUsersData, newState: Partial<TUsersData>): TUsersData => ({
      ...state,
      ...newState,
    }),
    INITIAL_USERS_STATE,
  );

  const [companyOfficeState, setcompanyOfficeState] = useReducer(
    (state: TCompanyOffice, newState: Partial<TCompanyOffice>): TCompanyOffice => ({
      ...state,
      ...newState,
    }),
    INITIAL_COMPANY_OFFICE_STATE,
  );

  const value = {
    userTypeModulesState,
    usersState,
    companyOfficeState,
    userVisibilityState,

    setUserTypeModulesState,
    setUserVisibilityState,
    setUsersState,
    setcompanyOfficeState,
  };

  return <UserManagementContext.Provider value={value}>{children}</UserManagementContext.Provider>;
};
